import PropTypes from 'prop-types';
// @mui
import { alpha, styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
// components
import MyAvatarNav from 'src/components/myAvatarNav';
// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  minWidth: 0,
  padding: theme.spacing(1.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  border: `1px solid ${alpha(theme.palette.grey[500], 0.16)}`,
  backgroundColor: alpha(theme.palette.grey[500], 0.08),
}));

// ----------------------------------------------------------------------

NavbarAccount.propTypes = {
  isCollapse: PropTypes.bool,
  profile: PropTypes.object,
};

export default function NavbarAccount({ isCollapse, profile }) {
  return (
    <RootStyle
      sx={{
        ...(isCollapse && {
          bgcolor: 'transparent',
          borderColor: 'transparent',
          justifyContent: 'center',
          p: 1,
        }),
      }}
    >
      <MyAvatarNav
        profileDetails={profile}
        sx={{
          width: isCollapse ? 40 : 44,
          height: isCollapse ? 40 : 44,
          flexShrink: 0,
        }}
      />

      <Box
        sx={{
          minWidth: 0,
          flexGrow: 1,
          ml: 1.5,
          overflow: 'hidden',
          opacity: 1,
          transition: (theme) =>
            theme.transitions.create(['width', 'margin-left', 'opacity'], {
              duration: theme.transitions.duration.shorter,
            }),
          ...(isCollapse && {
            ml: 0,
            width: 0,
            flexGrow: 0,
            opacity: 0,
          }),
        }}
      >
        <Typography variant="subtitle2" noWrap>
          {profile?.first_name} {profile?.last_name ? profile?.last_name : ''}
        </Typography>
        <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
          {profile?.person_title}
        </Typography>
      </Box>
    </RootStyle>
  );
}
